import { render, staticRenderFns } from "./ShippingDelivery.vue?vue&type=template&id=9f89df9a"
import script from "./ShippingDelivery.vue?vue&type=script&lang=js"
export * from "./ShippingDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports